import { TweenMax } from 'gsap';
import { Container } from 'pixi.js';
import { getGameSize, IGameSizeInfo } from '../../Config/Levels';
import Rectangle = PIXI.Rectangle;
import { createRect } from '../../Utils/Utils';

export class ScreenOverlay extends Container {
    constructor() {
        super();

        const gameSize: IGameSizeInfo = getGameSize();
        const overlay = createRect(
            new Rectangle(0, 0, gameSize.gameWidth, gameSize.gameHeight),
            0x000000,
            0x000000,
            1
        );
        overlay.alpha = 0.3;
        this.addChild(overlay);

        this.interactive = true;
    }

    public cacheOverlay() {
        // this.cacheAsBitmap = true;
    }

    public fade(targetAlpha: number, ms: number) {
        TweenMax.killTweensOf(this);
        TweenMax.to(this, ms / 1000, {
            alpha: targetAlpha,
            onComplete: () => {
                if (targetAlpha === 0) {
                    this.destroy();
                }
            },
        });
    }
}
